var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#ABEAFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2294 9.34451C19.2294 8.78311 18.7803 8.33398 18.2189 8.33398H7.12185C6.56045 8.33398 6.11133 8.78311 6.11133 9.34451V10.4299H19.2294V9.34451Z",
    fill: "#1b4597"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2482 12.8654V11.9297H6.11133V16.2899C6.11133 16.8513 6.56045 17.3004 7.12185 17.3004H15.5055C15.5803 15.111 17.171 13.2958 19.2482 12.8654ZM9.38618 15.4665C9.38618 15.5788 9.29261 15.6724 9.18033 15.6724H7.79554C7.68326 15.6724 7.58969 15.5788 7.58969 15.4665V14.7367C7.58969 14.6244 7.68326 14.5309 7.79554 14.5309H9.18033C9.29261 14.5309 9.38618 14.6244 9.38618 14.7367V15.4665ZM12.1745 15.4665C12.1745 15.5788 12.0809 15.6724 11.9686 15.6724H10.5838C10.4716 15.6724 10.378 15.5788 10.378 15.4665V14.7367C10.378 14.6244 10.4716 14.5309 10.5838 14.5309H11.9686C12.0809 14.5309 12.1745 14.6244 12.1745 14.7367V15.4665ZM14.9628 15.4665C14.9628 15.5788 14.8692 15.6724 14.7569 15.6724H13.3721C13.2599 15.6724 13.1663 15.5788 13.1663 15.4665V14.7367C13.1663 14.6244 13.2599 14.5309 13.3721 14.5309H14.7569C14.8692 14.5309 14.9628 14.6244 14.9628 14.7367V15.4665Z",
    fill: "#1b4597"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2027 13.7637C18.1629 13.7637 16.5161 15.4105 16.5161 17.4502C16.5161 19.49 18.1629 21.1368 20.2027 21.1368C22.2424 21.1368 23.8892 19.49 23.8892 17.4502C23.8892 15.4292 22.2424 13.7637 20.2027 13.7637ZM21.943 16.8888L20.0904 18.7414C19.9968 18.835 19.8658 18.8912 19.7348 18.8912C19.6038 18.8912 19.4728 18.835 19.3793 18.7414L18.4623 17.8245C18.2565 17.6186 18.2565 17.3005 18.4623 17.1134C18.6682 16.9075 18.9863 16.9075 19.1734 17.1134L19.7348 17.6748L21.2319 16.1777C21.4377 15.9719 21.7559 15.9719 21.943 16.1777C22.1301 16.3836 22.1301 16.7017 21.943 16.8888Z",
    fill: "#1b4597"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThree);
export default __webpack_public_path__ + "static/media/three.dfb1921a9e7f745f0ca76e699914f6ec.svg";
export { ForwardRef as ReactComponent };